import React, { useState } from "react";

const CustomModal = ({ isOpen, onRequestClose }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [body, setBody] = useState("");

  async function sendEmail() {
    const response = await fetch("/api/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone_number: phone,
        body: body,
      }),
    });

    return response.json();
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    // will have emailJS script here
    // send mail on http://localhost:8080/contact
    const res = sendEmail();

    // clear the form
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setBody("");

    // Close the modal
    onRequestClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-2xl mx-4">
        <h2 className="text-3xl mb-6 text-center font-semibold">
          Get in touch
        </h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-6 flex space-x-4">
            <div className="w-1/2">
              <label className="block text-gray-700 text-lg mb-2">
                First Name:<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div className="w-1/2">
              <label className="block text-gray-700 text-lg mb-2">
                Last Name:<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
                className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-lg mb-2">
              Email:<span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-lg mb-2">Phone:</label>
            <input
              type="tel"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="mb-6">
            <label className="block text-gray-700 text-lg mb-2">
              Please let us know how we can help:
              <span className="text-red-500">*</span>
            </label>
            <textarea
              value={body}
              onChange={(e) => setBody(e.target.value)}
              required
              className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows="6"
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onRequestClose}
              className="mr-4 px-6 py-3 bg-white text-gray-700 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-3 bg-[#2d9376] text-white rounded-lg hover:bg-[#2d9376] focus:outline-none focus:ring-2 focus:bg-green-300"
            >
              Send
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomModal;
